export const CONTROL_VISIBILITY_CHANGED_EVENT = "DevOwl/Customize/Control/VisibilityChanged";
